import glamorous from 'glamorous';
import { mediaQueries } from '../../constants/mediaqueries.const';

const SubmitFormWrapper = glamorous.div(() => ({
  width: '100%',
  padding: '8px',
  [mediaQueries.tablet]: {
  },
  [mediaQueries.desktopLG]: {
  },
  ' .maxim-link:hover': {
    color: '#b0b0b0',
  },
}));
SubmitFormWrapper.displayName = 'SubmitFormWrapper';

export default SubmitFormWrapper;



// WEBPACK FOOTER //
// ./src/containers/SubmitForm/SubmitForm.style.js